// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--f9978";
export var bottom = "Footer-module--bottom--217fa";
export var licenseLink = "Footer-module--licenseLink--da065";
export var socialLink = "Footer-module--socialLink--184e5";